const translation = {
  custom: 'व्यक्तिकरण',
  upgradeTip: {
    prefix: 'अपग्रेड करें अपने प्लान को',
    suffix: 'स्वयं अपना ब्रांड चुनना।',
    title: 'अपने योजना को अपग्रेड करें',
    des: 'अपने ब्रांड को कस्टमाइज़ करने के लिए अपने योजना को अपग्रेड करें',
  },
  webapp: {
    title: 'web app का ब्रांड व्यक्तिकरण करें',
    removeBrand: 'पावर्ड द्वारा डिफी हटाएं',
    changeLogo: 'पावर्ड द्वारा ब्रांड छवि बदले',
    changeLogoTip: 'SVG या PNG प्रारूप के साथ न्यूनतम आकार 40x40px होना चाहिए',
  },
  app: {
    title: 'हेडर का ब्रांड व्यक्तिकरण करें',
    changeLogoTip: 'SVG या PNG प्रारूप के साथ न्यूनतम आकार 80x80px होना चाहिए',
  },
  upload: 'चढ़ाएं',
  uploading: 'चढ़ाएं...',
  uploadedFail: 'चित्र अपलोड असफल है, कृपया फिर से अपलोड करें।',
  change: 'बदलें',
  apply: 'लगाएं',
  restore: 'डिफ़ॉल्ट रिकवरी',
  customize: {
    contactUs: ' हमसे संपर्क करें ',
    prefix: 'अप्लीकेशन में ब्रांड लोगो बदलने के लिए, कृपया',
    suffix: ' Enterprise संस्करण में अपग्रेड करें.',
  },
}

export default translation
